class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.progressLines = [];
    this.autoplayInterval = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  initSwiper() {
    const effect = this.dataset.effect || 'slide';
    const loop = this.dataset.loop === 'true';
    const speed = parseInt(this.dataset.speed) || 600;
    const autoplay = this.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;
    const hasProgressLines = this.dataset.progressLines === 'true';

    // Initialize Swiper
    if (typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(this, {
        effect: effect,
        loop: loop,
        speed: speed,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: () => {
            this.handleSlideChange();
            this.loadVideos();
            setTimeout(() => {
              this.classList.remove('lazy-loading-swiper-before');
            }, 100);
          },
          slideChange: () => {
            this.handleSlideChange();
          },
        },
      });

      // Setup autoplay with progress lines
      if (autoplay && hasProgressLines) {
        this.setupAutoplayWithProgress(autoplaySpeed);
      } else if (autoplay) {
        this.swiper.params.autoplay = {
          delay: autoplaySpeed * 1000,
          disableOnInteraction: false,
        };
        this.swiper.autoplay.start();
      }
    } else {
      console.warn('Swiper library not loaded');
    }
  }

  setupAutoplayWithProgress(speed) {
    const progressWrapper = this.querySelector('[data-progress-lines-wrapper]');
    if (!progressWrapper) return;

    const progressFills = progressWrapper.querySelectorAll('[data-progress-fill]');
    this.progressLines = Array.from(progressFills);

    let currentProgress = 0;
    const intervalTime = 50; // Update every 50ms
    const totalTime = speed * 1000;
    const incrementPerInterval = (intervalTime / totalTime) * 100;

    const updateProgress = () => {
      const activeIndex = this.swiper?.realIndex || 0;
      const activeFill = this.progressLines[activeIndex];

      if (!activeFill) return;

      currentProgress += incrementPerInterval;

      if (currentProgress >= 100) {
        currentProgress = 0;
        activeFill.style.width = '100%';
        
        setTimeout(() => {
          if (this.swiper) {
            this.swiper.slideNext();
          }
        }, 100);
      } else {
        activeFill.style.width = currentProgress + '%';
      }
    };

    this.autoplayInterval = setInterval(updateProgress, intervalTime);

    // Reset progress on manual slide change
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        currentProgress = 0;
        this.progressLines.forEach((fill, index) => {
          fill.style.width = index === this.swiper.realIndex ? '0%' : '0%';
        });
      });
    }
  }

  handleSlideChange() {
    // Pause all videos
    const videos = this.querySelectorAll('video');
    videos.forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });

    // Play video in active slide
    const activeSlide = this.querySelector('.swiper-slide-active');
    if (activeSlide) {
      const activeVideo = activeSlide.querySelector('video[data-src]');
      if (activeVideo && !activeVideo.src) {
        activeVideo.src = activeVideo.dataset.src;
      }
      if (activeVideo) {
        activeVideo.play().catch(() => {
          // Auto-play was prevented
        });
      }
    }
  }

  loadVideos() {
    const videos = this.querySelectorAll('video[data-src]');
    videos.forEach((video, index) => {
      if (index === 0 || index === 1) {
        video.src = video.dataset.src;
      }
    });
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('slide-section')) {
  customElements.define('slide-section', SlideSection);
}
